import { clampMagnitude } from '@studio/models/ptz';
import { toNumber } from '@tryiris-ai/js-types';
import { MaxOffset } from './constants.js';
import type { Offset } from './types.js';
import { inDeadZone } from '#~/gamepad/index.js';

/** @internal */
export const toOffset = (axes: readonly number[], index: 1 | 2): Offset => {
  const x = clampMagnitude(toNumber(axes[(index - 1) * 2], { default: 0 }));
  const y = clampMagnitude(toNumber(axes[(index - 1) * 2 + 1], { default: 0 }));

  return {
    x: !inDeadZone(x) ? Math.round(x * MaxOffset) : 0,
    y: !inDeadZone(y) ? Math.round(y * MaxOffset) : 0
  };
};
